module.exports = "<div class=form-group> <label ng-transclude=translatableLabel></label> <p class=form-control-static>{{:: $ctrl.text }}</p> </div>";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/static/text/partial.html
// module id = 562
// module chunks = 0